import { Component, Injector, OnInit } from '@angular/core';
import { CoCauToChucControlSchema, ComponentContextService, DataFormBase, EventData, FormSchemaBase, OrganizationPickerControlSchema, OrganizationService, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'app-organization-form',
    templateUrl: './organization-form.component.html',
    styleUrls: ['./organization-form.component.scss'],
    providers: [ComponentContextService],
})
export class OrganizationFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _organizationService: OrganizationService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();


        this.setting.baseService = this._organizationService;

        this.setting.schema = <FormSchemaBase[]>[

            new TextControlSchema({
                field: 'code',
                label: 'Mã',
                required: true
            }),

            new TextControlSchema({
                field: 'ten',
                label: 'Tên',
                required: true
            }),

            new CoCauToChucControlSchema({
                field: 'idCha',
                label: 'Thuộc phòng ban',
                // validators: {
                //     required: true
                // },
                multiple: false,
                parentOrgId: null,
                isUsingId: true
            }),

            new TextControlSchema({
                field: 'thuTu',
                label: 'Số thứ tụ',
                dataFormat: 'number'
            }),
        ];
    }

    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        if (this.model.data.id) {
        } else {
        }
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }

}
